import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import { noMatchesText } from "./NoMatchesOverlay_vanilla.css";

export const NoMatchesOverlay = () => (
  <Flex flexDirection="column" alignItems="center" justifyContent="center" gap={SPACING.LARGE}>
    <Icon type="search" size="xx-large" color={Colors.Neutral600} />
    <Text variant="h4" align="center" className={noMatchesText}>
      No matches found
    </Text>
  </Flex>
);
